const WORK_CASES = [
    {
        id: "droneAgri",
        image: "droneAgri",
        tag: {
            ja: "\u81EA\u793E\u30C9\u30ED\u30FC\u30F3 \xd7 \u8FB2\u696D",
            en: "In-house drone \xd7 agriculture"
        },
        title: {
            ja: "\u81EA\u5F8B\u63A2\u7D22\u30C9\u30ED\u30FC\u30F3\u306B\u3088\u308B\u7A7A\u64AE\u3068\u5206\u5E03\u30DE\u30C3\u30D7\u306EPoC",
            en: "PoC: autonomous scouting, aerials, distribution maps"
        },
        desc: {
            ja: "\u81EA\u793E\u958B\u767A\u306E\u753B\u50CF\u8A8D\u8B58\u642D\u8F09\u30C9\u30ED\u30FC\u30F3\u3067\u5703\u5834\u4E0A\u7A7A\u3092\u81EA\u5F8B\u8D70\u884C\u3002GPS\u3068\u7A7A\u64AE\u30C7\u30FC\u30BF\u3092\u9023\u643A\u3057\u3001\u75C5\u5BB3\u866B\u306E\u5206\u5E03\u3092\u30DE\u30C3\u30D7\u5316\u3059\u308B\u4E00\u9023\u306E\u691C\u8A3C\u3092\u3001\u30CF\u30FC\u30C9\u30FB\u30BD\u30D5\u30C8\u4E00\u4F53\u3067\u5B9F\u65BD\u3057\u307E\u3057\u305F\u3002",
            en: "Our in-house vision-guided drone autonomously scanned fields\u2014linking GPS and aerial capture to validate distribution-map analytics as one hardware\u2013software stack."
        },
        highlights: [
            {
                ja: "\u5703\u5834\u8D70\u67FB\u30EB\u30FC\u30C8\u306E\u81EA\u52D5\u751F\u6210\u3068\u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u4F4D\u7F6E\u540C\u671F",
                en: "Auto-generated flight paths with live GPS sync"
            },
            {
                ja: "\u7A7A\u64AE\u753B\u50CF\u304B\u3089\u5206\u5E03\u30D2\u30FC\u30C8\u30DE\u30C3\u30D7\u3092\u751F\u6210\u3059\u308B\u89E3\u6790\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3",
                en: "Analytics pipeline turning aerials into distribution heatmaps"
            },
            {
                ja: "\u8FB2\u696D\u73FE\u5834\u306E\u30AA\u30DA\u30EC\u30FC\u30BF\u30FC\u304C\u4F7F\u3048\u308B\u30C0\u30C3\u30B7\u30E5\u30DC\u30FC\u30C9\u307E\u3067\u5B9F\u88C5",
                en: "Operator-ready dashboards for field teams"
            }
        ]
    },
    {
        id: "disasterWaste",
        image: "disasterWaste",
        tag: {
            ja: "\u9632\u707D \xd7 \u4E88\u6E2CAI",
            en: "Resilience \xd7 predictive AI"
        },
        title: {
            ja: "\u707D\u5BB3\u5EC3\u68C4\u7269\u306E\u767A\u751F\u91CF\u30FB\u8A2D\u7F6E\u30FB\u51E6\u7406\u30D5\u30ED\u30FC\u3092\u9AD8\u7CBE\u5EA6\u306B\u63A8\u5B9A",
            en: "Forecasting disaster waste volumes, placement, and flows"
        },
        desc: {
            ja: "\u81EA\u6CBB\u4F53\u306E\u30AA\u30FC\u30D7\u30F3\u30C7\u30FC\u30BF\u3001\u90FD\u5E02\u8A08\u753B\u3001\u5730\u56F3\u60C5\u5831\u3092\u6A2A\u65AD\u7D71\u5408\u3002\u88AB\u707D\u30B7\u30CA\u30EA\u30AA\u3054\u3068\u306B\u5EC3\u68C4\u7269\u306E\u767A\u751F\u91CF\u3068\u51E6\u7406\u62E0\u70B9\u306E\u914D\u7F6E\u3092\u30B7\u30DF\u30E5\u30EC\u30FC\u30B7\u30E7\u30F3\u3057\u3001\u73FE\u5834\u5224\u65AD\u3092\u652F\u3048\u308B\u53EF\u8996\u5316\u57FA\u76E4\u3092\u69CB\u7BC9\u3057\u307E\u3057\u305F\u3002",
            en: "We fused civic open data, urban planning, and mapping layers to simulate waste volumes and depot placement per disaster scenario\u2014shipping dashboards operators actually use."
        },
        highlights: [
            {
                ja: "\u8907\u6570\u81EA\u6CBB\u4F53\u30C7\u30FC\u30BF\u306E\u30AF\u30EC\u30F3\u30B8\u30F3\u30B0\u3068\u7D71\u5408\u30B9\u30AD\u30FC\u30DE\u8A2D\u8A08",
                en: "Cleansing and unified schemas across municipal datasets"
            },
            {
                ja: "\u88AB\u707D\u30D1\u30BF\u30FC\u30F3\u5225\u306E\u767A\u751F\u91CF\u30B7\u30DF\u30E5\u30EC\u30FC\u30B7\u30E7\u30F3\u30A8\u30F3\u30B8\u30F3",
                en: "Scenario-level volume simulation engine"
            },
            {
                ja: "\u51E6\u7406\u62E0\u70B9\u306E\u914D\u7F6E\u3068\u642C\u9001\u30D5\u30ED\u30FC\u3092\u4E00\u671B\u3067\u304D\u308B\u30DE\u30C3\u30D7UI",
                en: "Map UI surfacing depot placement and haul routes"
            }
        ]
    },
    {
        id: "pricingAi",
        image: "pricingAi",
        tag: {
            ja: "\u8D8A\u5883EC \xd7 \u4FA1\u683CAI",
            en: "Cross-border commerce \xd7 pricing AI"
        },
        title: {
            ja: "\u30B0\u30ED\u30FC\u30D0\u30EB\u8CB7\u53D6\u30FB\u8CA9\u58F2\u30C7\u30FC\u30BF\u306E\u53CE\u96C6\u57FA\u76E4\u3068\u4FA1\u683C\u4E88\u6E2C\u30E2\u30C7\u30EB",
            en: "Global pricing intelligence on a living dataset"
        },
        desc: {
            ja: "\u8907\u6570\u56FD\u30FB\u8907\u6570\u30DE\u30FC\u30B1\u30C3\u30C8\u30D7\u30EC\u30A4\u30B9\u304B\u3089\u4FA1\u683C\u30C7\u30FC\u30BF\u3092\u5E38\u6642\u53CE\u96C6\u3059\u308B\u30C7\u30FC\u30BF\u30EC\u30A4\u30AF\u3092\u69CB\u7BC9\u3002\u5B66\u7FD2\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u3068\u63A8\u8AD6API\u3092\u4E00\u4F53\u3067\u8A2D\u8A08\u3057\u3001\u76F8\u5834\u5909\u52D5\u306B\u8FFD\u5F93\u3059\u308B\u4E88\u6E2C\u6A5F\u80FD\u3092\u30D7\u30ED\u30C0\u30AF\u30C8\u306B\u7D44\u307F\u8FBC\u307F\u307E\u3057\u305F\u3002",
            en: "Built an always-on data lake ingesting prices across countries and marketplaces\u2014training loops and inference APIs embedded in the product so forecasts track live markets."
        },
        highlights: [
            {
                ja: "24\u6642\u9593\u7A3C\u50CD\u306E\u30AF\u30ED\u30FC\u30E9\u30FC\u3068\u54C1\u8CEA\u30C1\u30A7\u30C3\u30AF\u4ED8\u304D\u30C7\u30FC\u30BF\u30EC\u30A4\u30AF",
                en: "24/7 crawlers with quality-gated data lake ingestion"
            },
            {
                ja: "\u76F8\u5834\u30C8\u30EC\u30F3\u30C9\u3092\u53CD\u6620\u3059\u308B\u518D\u5B66\u7FD2\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3",
                en: "Retraining pipelines that follow market trends"
            },
            {
                ja: "\u8CB7\u53D6\u30FB\u8CA9\u58F2\u5224\u65AD\u3092\u652F\u63F4\u3059\u308B\u4E88\u6E2CAPI\u306E\u30D7\u30ED\u30C0\u30AF\u30C8\u7D71\u5408",
                en: "Forecast APIs wired into buy/sell decision workflows"
            }
        ]
    },
    {
        id: "ragChat",
        image: "ragChat",
        tag: {
            ja: "\u751F\u6210AI \xd7 \u793E\u5185\u30CA\u30EC\u30C3\u30B8",
            en: "GenAI \xd7 enterprise knowledge"
        },
        title: {
            ja: "RAG\u3068LLM\u3092\u7D44\u307F\u5408\u308F\u305B\u305F\u30A8\u30F3\u30BF\u30FC\u30D7\u30E9\u30A4\u30BA\u30C1\u30E3\u30C3\u30C8",
            en: "Enterprise chat blending RAG with LLMs"
        },
        desc: {
            ja: "\u793E\u5185\u898F\u7A0B\u30FB\u30DE\u30CB\u30E5\u30A2\u30EB\u30FB\u904E\u53BB\u6848\u4EF6\u306E\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u5B89\u5168\u306B\u691C\u7D22\u3057\u3001\u6839\u62E0\u4ED8\u304D\u3067\u56DE\u7B54\u3059\u308B\u30C1\u30E3\u30C3\u30C8\u3092\u69CB\u7BC9\u3002\u691C\u7D22\u3068\u751F\u6210\u3092\u5206\u96E2\u3057\u305F\u30A2\u30FC\u30AD\u30C6\u30AF\u30C1\u30E3\u3067\u3001\u904B\u7528\u30B3\u30B9\u30C8\u3068\u30CF\u30EB\u30B7\u30CD\u30FC\u30B7\u30E7\u30F3\u30EA\u30B9\u30AF\u3092\u6291\u3048\u307E\u3057\u305F\u3002",
            en: "Grounded chat over policies, manuals, and past engagements\u2014retrieval and generation decoupled to tame ops cost and hallucination risk."
        },
        highlights: [
            {
                ja: "\u30A2\u30AF\u30BB\u30B9\u6A29\u9650\u3092\u8E0F\u307E\u3048\u305F\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9\u8A2D\u8A08",
                en: "Permission-aware document indexing"
            },
            {
                ja: "\u5F15\u7528\u5143\u3092\u660E\u793A\u3059\u308B\u6839\u62E0\u4ED8\u304D\u56DE\u7B54UI",
                en: "Answers with explicit source citations"
            },
            {
                ja: "\u30D7\u30ED\u30F3\u30D7\u30C8\u30FB\u30A4\u30F3\u30C7\u30C3\u30AF\u30B9\u66F4\u65B0\u306E\u904B\u7528\u30D5\u30ED\u30FC\u6574\u5099",
                en: "Ops playbooks for prompt and index refresh"
            }
        ]
    },
    {
        id: "safetyNlp",
        image: "safetyNlp",
        tag: {
            ja: "\u5EFA\u8A2D\u5B89\u5168 \xd7 NLP",
            en: "Construction safety \xd7 NLP"
        },
        title: {
            ja: "\u6570\u4E07\u4EF6\u898F\u6A21\u306E\u707D\u5BB3\u4E8B\u4F8B\u30C6\u30AD\u30B9\u30C8\u3092\u81EA\u52D5\u5206\u985E\u30FB\u985E\u4F3C\u691C\u7D22",
            en: "Classifying & surfacing patterns across tens of thousands of incident narratives"
        },
        desc: {
            ja: "\u539A\u52B4\u7701\u306A\u3069\u304C\u516C\u958B\u3059\u308B\u5927\u91CF\u306E\u707D\u5BB3\u5831\u544A\u6587\u66F8\u3092\u6A5F\u68B0\u5B66\u7FD2\u3067\u30BF\u30B0\u4ED8\u3051\u30FB\u5206\u985E\u3002\u985E\u4F3C\u707D\u5BB3\u3092\u77AC\u6642\u306B\u691C\u7D22\u3067\u304D\u308B\u30CA\u30EC\u30C3\u30B8\u30D9\u30FC\u30B9\u3078\u5909\u63DB\u3057\u3001\u5EFA\u8A2D\u73FE\u5834\u306E\u5B89\u5168\u8A08\u753B\u306B\u6D3B\u304B\u305B\u308B\u5F62\u3067\u63D0\u4F9B\u3057\u307E\u3057\u305F\u3002",
            en: "Tagged and classified massive regulatory incident corpora\u2014turning free-text reports into a similar-case knowledge base for proactive safety planning on site."
        },
        highlights: [
            {
                ja: "\u65E5\u672C\u8A9E\u707D\u5BB3\u5831\u544A\u6587\u306E\u591A\u30E9\u30D9\u30EB\u81EA\u52D5\u5206\u985E\u30E2\u30C7\u30EB",
                en: "Multi-label classifiers for Japanese incident narratives"
            },
            {
                ja: "\u985E\u4F3C\u4E8B\u4F8B\u3092\u79D2\u5358\u4F4D\u3067\u5F15\u304F\u30D9\u30AF\u30C8\u30EB\u691C\u7D22\u57FA\u76E4",
                en: "Vector search surfacing similar cases in seconds"
            },
            {
                ja: "\u5B89\u5168\u62C5\u5F53\u8005\u5411\u3051\u306E\u691C\u7D22\u30FB\u30D5\u30A3\u30EB\u30BFUI",
                en: "Search and filter UI built for safety officers"
            }
        ]
    },
    {
        id: "energyForecast",
        image: "energyForecast",
        tag: {
            ja: "\u30A8\u30CD\u30EB\u30AE\u30FC \xd7 \u9700\u8981\u4E88\u6E2C",
            en: "Energy \xd7 demand forecasting"
        },
        title: {
            ja: "\u591A\u5909\u91CF\u30D3\u30C3\u30B0\u30C7\u30FC\u30BF\u3092\u7528\u3044\u305F\u96FB\u529B\u9700\u8981\u4E88\u6E2C\u3068\u52A3\u5316\u3057\u306B\u304F\u3044\u5B66\u7FD2\u57FA\u76E4",
            en: "Robust power-demand forecasting on heterogeneous big data"
        },
        desc: {
            ja: "\u6C17\u8C61\u30FB\u9700\u8981\u30FB\u518D\u30A8\u30CD\u51FA\u529B\u306A\u3069\u8907\u6570\u6642\u7CFB\u5217\u3092\u7D71\u5408\u3057\u305F\u9700\u8981\u4E88\u6E2C\u30E2\u30C7\u30EB\u3092\u958B\u767A\u3002\u30E2\u30C7\u30EB\u52A3\u5316\u3092\u691C\u77E5\u3059\u308B\u30E2\u30CB\u30BF\u30EA\u30F3\u30B0\u3068\u518D\u5B66\u7FD2\u8A2D\u8A08\u3092\u4E00\u4F53\u3067\u6574\u5099\u3057\u3001\u9577\u671F\u904B\u7528\u3092\u898B\u636E\u3048\u305FMLOps\u57FA\u76E4\u3092\u69CB\u7BC9\u3057\u307E\u3057\u305F\u3002",
            en: "Fused weather, demand, and renewables signals into forecasting models\u2014with drift monitoring and retraining designed for long-run MLOps."
        },
        highlights: [
            {
                ja: "\u6C17\u8C61\u30FB\u9700\u8981\u30FB\u518D\u30A8\u30CD\u306E\u591A\u7CFB\u5217\u7279\u5FB4\u30A8\u30F3\u30B8\u30CB\u30A2\u30EA\u30F3\u30B0",
                en: "Multi-series features across weather, demand, and renewables"
            },
            {
                ja: "\u4E88\u6E2C\u7CBE\u5EA6\u306E\u30C9\u30EA\u30D5\u30C8\u691C\u77E5\u3068\u30A2\u30E9\u30FC\u30C8\u8A2D\u8A08",
                en: "Drift detection and alerting on forecast accuracy"
            },
            {
                ja: "\u5B9A\u671F\u518D\u5B66\u7FD2\u3092\u56DE\u3059\u30AF\u30E9\u30A6\u30C9\u4E0A\u306E\u5B66\u7FD2\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3",
                en: "Cloud training pipelines for scheduled refresh"
            }
        ]
    },
    {
        id: "receiptOcr",
        image: "receiptOcr",
        tag: {
            ja: "\u6D88\u8CBB\u8CA1 \xd7 OCR",
            en: "Consumer goods \xd7 OCR"
        },
        title: {
            ja: "\u30EC\u30B7\u30FC\u30C8\u753B\u50CF\u304B\u3089\u306E\u691C\u77E5\u30FB\u8A8D\u8B58\u30FB\u69CB\u9020\u5316\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3",
            en: "Detection, recognition, structuring for receipt imagery"
        },
        desc: {
            ja: "\u30B9\u30DE\u30DB\u64AE\u5F71\u3055\u308C\u305F\u30EC\u30B7\u30FC\u30C8\u753B\u50CF\u304B\u3089\u5546\u54C1\u30FB\u91D1\u984D\u30FB\u5E97\u8217\u60C5\u5831\u3092\u81EA\u52D5\u62BD\u51FA\u3002\u691C\u77E5\u2192OCR\u2192\u69CB\u9020\u5316\u306E3\u6BB5\u30D1\u30A4\u30D7\u30E9\u30A4\u30F3\u3068\u4EBA\u7684\u78BA\u8A8D\u30D5\u30ED\u30FC\u3092\u7D44\u307F\u5408\u308F\u305B\u3001\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u8ABF\u67FB\u306E\u8EE2\u8A18\u5DE5\u6570\u3092\u5927\u5E45\u306B\u524A\u6E1B\u3057\u307E\u3057\u305F\u3002",
            en: "Auto-extracted items, amounts, and store metadata from phone-captured receipts\u2014detect \u2192 OCR \u2192 structure with human-in-the-loop QA, slashing transcription load for insight programs."
        },
        highlights: [
            {
                ja: "\u64AE\u5F71\u30D6\u30EC\u30FB\u5F71\u306B\u5F37\u3044\u30EC\u30B7\u30FC\u30C8\u9818\u57DF\u306E\u81EA\u52D5\u691C\u51FA",
                en: "Robust receipt-region detection despite blur and shadow"
            },
            {
                ja: "\u30AD\u30FC\u9805\u76EE\u306E\u69CB\u9020\u5316JSON\u51FA\u529B\u3068\u7CBE\u5EA6\u30B9\u30B3\u30A2\u30EA\u30F3\u30B0",
                en: "Structured JSON output with per-field confidence"
            },
            {
                ja: "\u4F4E\u4FE1\u983C\u30C7\u30FC\u30BF\u3060\u3051\u3092\u4EBA\u304C\u78BA\u8A8D\u3059\u308B\u30EC\u30D3\u30E5\u30FC\u753B\u9762",
                en: "Review UI routing only low-confidence rows to humans"
            }
        ]
    }
];

//# sourceMappingURL=corporate-site.b9a8b6ce.js.map
